import LocationErrorPage from './LocationErrorPage';
export default LocationErrorPage;
